/** The KYC API reports OCR confidence in percentage points (0–100). */
export function formatOcrConfidence(confidence: number | null | undefined): string {
  return confidence == null ? '—' : `${confidence.toFixed(1)}%`;
}
